import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { HelpCircle } from "lucide-react";

export default function FAQ() {
  const faqs = [
    {
      question: "How does AlphaBot work?",
      answer: "AlphaBot is an Expert Advisor (EA) for MetaTrader 5 that uses advanced algorithms to analyze market conditions and execute trades automatically. It combines technical indicators, price action, and risk management to identify high-probability trading opportunities."
    },
    {
      question: "Which brokers are compatible?",
      answer: "AlphaBot works with any broker that supports MetaTrader 5. We recommend using ECN brokers with low spreads and fast execution for optimal performance. Popular choices include IC Markets, Pepperstone, and FP Markets."
    },
    {
      question: "What is the minimum account size?",
      answer: "We recommend a minimum account size of $1,000 for the Base plan. For optimal performance and risk management, $5,000+ is recommended. The bot scales position sizes based on your account balance and configured risk settings."
    },
    {
      question: "Can I use this on a demo account first?",
      answer: "Absolutely! We encourage all users to test AlphaBot on a demo account first to familiarize themselves with the settings and performance before going live."
    },
    {
      question: "What is your refund policy?",
      answer: "All subscriptions are non-refundable once activated. We encourage testing on a demo account first and reviewing our performance data before subscribing. Contact support if you have billing questions."
    },
    {
      question: "How risky is automated trading?",
      answer: "All trading involves risk, and AlphaBot is no exception. However, the bot includes built-in risk management features like stop-loss, maximum daily drawdown limits, and position sizing. Never trade with money you can't afford to lose."
    },
    {
      question: "Do I need to keep my computer on 24/7?",
      answer: "For continuous trading, yes. We strongly recommend using a VPS (Virtual Private Server) to ensure the bot runs 24/7 without interruption. Many brokers offer free VPS hosting to their clients."
    },
    {
      question: "Can I customize the trading strategy?",
      answer: "Pro and Institutional users can access advanced settings to customize risk per trade, risk per day, trading hours, currency pairs, and more. The Base plan uses optimized default settings with limited customization."
    },
    {
      question: "How do I install the bot?",
      answer: "After subscribing, add your MT5 account number, server, and password in the dashboard and wait for verification. Configure your risk settings, then turn on the automatic trading switch. See the How It Works page for full details."
    },
    {
      question: "What kind of support do you offer?",
      answer: "Base users get email support within 24 hours. Pro users get priority 24/7 support via email and live chat. Institutional clients receive a dedicated account manager for personalized assistance."
    }
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      
      <div className="pt-24 pb-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <HelpCircle className="w-16 h-16 text-[#00E676] mx-auto mb-4" />
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
              Frequently Asked Questions
            </h1>
            <p className="text-lg text-[#A1A1AA]">
              Everything you need to know about AlphaBot
            </p>
          </div>

          <div className="bg-[#111111] border border-[#27272A] rounded-lg p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, idx) => (
                <AccordionItem key={idx} value={`item-${idx}`} className="border-[#27272A]">
                  <AccordionTrigger className="text-left hover:text-[#00E676] transition-colors">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#A1A1AA]">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
